import { TREND_NOTE } from '../../constants';

// How many rows each list holds. The footnote quotes it, so it's stated once.
export const TOP_N = 3;

export const HEADER_TEXT = {
    title: 'Strengths and growth movement',
    description: "The latest 360's top strengths and top growth areas, tagged by whether each category was already on the list at the earlier 360 or is new to it.",
    notes: [
        `"New to the list" = not in the top ${TOP_N} at the earlier 360. "Stayed on the list" = in the top ${TOP_N} at both time points. Categories that dropped out are listed under each table.`,
        TREND_NOTE,
    ],
};

export const MOVEMENT = {
    NEW: 'NEW_TO_LIST',
    STAYED: 'STAYED_ON_LIST',
};

export const MOVEMENT_LABEL = {
    [MOVEMENT.NEW]: 'New to the list',
    [MOVEMENT.STAYED]: 'Stayed on the list',
};

export const DROPPED_LABEL = 'left the list';
